import { InvitationStatus } from './collaborate.types';

interface UserDetail {
  content: string;
  type: string;
}

interface User {
  id: number;
  nickname: string;
  profile_picture: string;
  details: UserDetail[];
}

export interface DesygnerUserInfo {
  is_admin: boolean;
  id: number;
  status: InvitationStatus;
  user?: User;
  expire_date?: string;
  invite_date: string;
  locale: string;
  details: UserDetail[];
  invite_link_expires_at?: string;
  is_expired: boolean;
  name?: string;
  email: string;
}

export const DESYGNER_TEAM_ID = 1;

export type Team = {
  id: number;
  domain: string;
};
